export default __webpack_public_path__ + "static/media/marker.f8e029ec.svg";